<template>
  <div>
    <form class="form-inline flex-wrap" @submit.prevent="submit" @reset.prevent="reset">
      <select class="form-control form-control-sm mr-1 mb-1" style="flex: 1 1 120px" v-model="i.responseCode">
        <option value="">Response Code</option>
        <option value="200">200</option>
        <option value="307">307</option>
        <option value="400">400</option>
        <option value="401">401</option>
        <option value="403">403</option>
        <option value="404">404</option>
        <option value="408">408</option>
        <option value="422">422</option>
        <option value="429">429</option>
        <option value="500">500</option>
      </select>
      <select
        class="form-control form-control-sm mr-1 mb-1"
        v-model="i.responseError"
        style="flex: 1 1 180px"
      >
        <option value="">Response Error</option>
        <option
          v-for="err in errorCodes"
          :key="err.code"
          :value="err.code"
        >
          {{ err.code }}
        </option>
      </select>
      <flat-pickr
        v-model="periodEnd"
        :config="flatpickrConfig"
        class="form-control form-control-sm mr-1 mb-1"
        style="flex: 1 1 160px"
        placeholder="To date/time (30 days)"
      />
      <input
        type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="From date"
        v-model="i.periodStart"
        disabled
        style="flex: 1 1 160px"
        v-if="false"
      />
      <select
        class="form-control form-control-sm mr-1 mb-1 bg-white"
        v-model="i.country"
        style="flex: 1 1 120px"
      >
        <option value="">Country</option>
        <option v-for="c in countriesEEA" :key="c.code" :value="c.code">
          {{ c.code }} – {{ c.name }}
        </option>
      </select>
      <select class="form-control form-control-sm mr-1 mb-1" v-model="i.brand" :disabled="!i.country || loadingASPSPs"
        :class="{ 'bg-white': i.country && !loadingASPSPs, 'bg-light text-muted': !i.country || loadingASPSPs }"
        :style="{ flex: '1 1 200px', cursor: (!i.country || loadingASPSPs) ? 'not-allowed' : 'auto' }">
        <option :value="i.country && !loadingASPSPs ? '' : (i.brand = '', '')">
          {{ loadingASPSPs ? 'Loading ASPSPs...' : (i.country ? 'ASPSP' : 'ASPSP (select country)') }}
        </option>
        <option v-if="!loadingASPSPs && (!countries || !countries[i.country] || countries[i.country].length === 0)" disabled>
          No ASPSPs found
        </option>
        <option v-for="aspsp in (countries && countries[i.country] ? countries[i.country] : [])" :key="aspsp.name"
          :value="aspsp.name" v-if="!loadingASPSPs">
          {{ aspsp.name }}
        </option>
      </select>
      <input type="text" class="form-control form-control-sm mr-1 mb-1" placeholder="Authorization ID"
        v-model="i.authorizationId" style="flex: 1 1 150px" />
      <input
        type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="Session ID"
        v-model="i.sessionId"
        style="flex: 1 1 150px" />
      <input
        type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="Request ID"
        v-model="i.requestId"
        style="flex: 1 1 150px" />
      <input
        type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="Account ID"
        v-model="i.accountId"
        style="flex: 1 1 150px" />
      <input
        type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="Payment ID"
        v-model="i.paymentId"
        style="flex: 1 1 150px" />
      <input type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="PSU ID or Hash"
        v-model="i.psuIdHash"
        style="flex: 1 1 150px" />
      <input type="text"
        class="form-control form-control-sm mr-1 mb-1"
        placeholder="Redirect URL State"
        v-model="i.state"
        style="flex: 1 1 150px" />
      <input type="submit" class="btn btn-sm btn-primary mr-1 mb-1" value="Apply" :disabled="!canSubmit" />
      <input type="reset" class="btn btn-sm btn-link mb-1" value="Reset" :disabled="!canReset" />
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from 'axios'

export default {
  data() {
    return {
      aspsps: [],
      loadingASPSPs: false,
      countriesEEA: [
        { code: 'AT', name: 'Austria' },
        { code: 'BE', name: 'Belgium' },
        { code: 'BG', name: 'Bulgaria' },
        { code: 'HR', name: 'Croatia' },
        { code: 'CY', name: 'Cyprus' },
        { code: 'CZ', name: 'Czechia' },
        { code: 'DK', name: 'Denmark' },
        { code: 'EE', name: 'Estonia' },
        { code: 'FI', name: 'Finland' },
        { code: 'FR', name: 'France' },
        { code: 'DE', name: 'Germany' },
        { code: 'GR', name: 'Greece' },
        { code: 'HU', name: 'Hungary' },
        { code: 'IS', name: 'Iceland' },
        { code: 'IE', name: 'Ireland' },
        { code: 'IT', name: 'Italy' },
        { code: 'LV', name: 'Latvia' },
        { code: 'LI', name: 'Liechtenstein' },
        { code: 'LT', name: 'Lithuania' },
        { code: 'LU', name: 'Luxembourg' },
        { code: 'MT', name: 'Malta' },
        { code: 'NL', name: 'Netherlands' },
        { code: 'NO', name: 'Norway' },
        { code: 'PL', name: 'Poland' },
        { code: 'PT', name: 'Portugal' },
        { code: 'RO', name: 'Romania' },
        { code: 'SK', name: 'Slovakia' },
        { code: 'SI', name: 'Slovenia' },
        { code: 'ES', name: 'Spain' },
        { code: 'SE', name: 'Sweden' },
        { code: 'GB', name: 'United Kingdom' }
      ],
      errorCodes: [
        { code: 'ACCESS_DENIED', description: 'Access to this resource is denied. Check services available for your application.' },
        { code: 'ACCOUNT_DOES_NOT_EXIST', description: 'No account found matching provided id' },
        { code: 'ALREADY_AUTHORIZED', description: 'Session is already authorized' },
        { code: 'ASPSP_ACCOUNT_NOT_ACCESSIBLE', description: "The PSU does not have access to the requested account or it doesn't exist" },
        { code: 'ASPSP_ERROR', description: 'Error interacting with ASPSP' },
        { code: 'ASPSP_PAYMENT_NOT_ACCESSIBLE', description: 'Payment can not be requested from the ASPSP' },
        { code: 'ASPSP_PSU_ACTION_REQUIRED', description: 'PSU action is required to proceed' },
        { code: 'ASPSP_RATE_LIMIT_EXCEEDED', description: 'ASPSP Rate limit exceeded' },
        { code: 'ASPSP_TIMEOUT', description: 'Timeout interacting with ASPSP' },
        { code: 'AUTHORIZATION_NOT_PROVIDED', description: 'Authorization header is not provided' },
        { code: 'CLOSED_SESSION', description: 'Session is closed' },
        { code: 'DATE_FROM_IN_FUTURE', description: 'date_from can not be in the future' },
        { code: 'DATE_TO_WITHOUT_DATE_FROM', description: 'date_from must be provided if date_to provided' },
        { code: 'EXPIRED_AUTHORIZATION_CODE', description: 'Authorization code is expired' },
        { code: 'EXPIRED_SESSION', description: 'Session is expired' },
        { code: 'INVALID_ACCOUNT_ID', description: 'Either iban or other account identification is required' },
        { code: 'INVALID_HOST', description: 'Invalid host' },
        { code: 'INVALID_PAYMENT', description: 'Invalid or expired payment provided' },
        { code: 'NO_ACCOUNTS_ADDED', description: 'No allowed accounts added to the application' },
        { code: 'PAYMENT_LIMIT_EXCEEDED', description: 'The amount value or the number of transactions exceeds the limit' },
        { code: 'PAYMENT_NOT_FINALIZED', description: 'You can not delete a payment that is not finalized or cancelled' },
        { code: 'PAYMENT_NOT_FOUND', description: 'Payment not found' },
        { code: 'PSU_HEADER_NOT_PROVIDED', description: 'Required PSU header not provided' },
        { code: 'REDIRECT_URI_NOT_ALLOWED', description: 'Redirect URI not allowed' },
        { code: 'REVOKED_SESSION', description: 'Session is revoked' },
        { code: 'SESSION_DOES_NOT_EXIST', description: 'No session found matching provided id' },
        { code: 'TRANSACTION_DOES_NOT_EXIST', description: 'No transaction found matching provided id' },
        { code: 'UNAUTHORIZED_ACCESS', description: 'Unauthorized access' },
        { code: 'UNAUTHORIZED_IP', description: 'Used IP address is not authorized to access the resource' },
        { code: 'UNTRUSTED_PAYMENT_PARTY', description: 'Either creditor or debtor account is not trusted' },
        { code: 'WEBHOOK_URI_NOT_ALLOWED', description: 'Webhook URI not allowed' },
        { code: 'WRONG_ASPSP_PROVIDED', description: 'Wrong ASPSP name provided' },
        { code: 'WRONG_AUTHORIZATION_CODE', description: 'Wrong authorization code provided' },
        { code: 'WRONG_CONTINUATION_KEY', description: 'Wrong continuation key provided' },
        { code: 'WRONG_CREDENTIALS_PROVIDED', description: 'Wrong credentials provided' },
        { code: 'WRONG_DATE_INTERVAL', description: 'date_from should be less than or equal date_to' },
        { code: 'WRONG_REQUEST_PARAMETERS', description: 'Wrong request parameters provided' },
        { code: 'WRONG_SESSION_STATUS', description: 'Wrong session status' },
        { code: 'WRONG_TRANSACTIONS_PERIOD', description: 'Wrong transactions period requested' }
      ],
      periodEnd: null,
      periodStart: null,
      flatpickrConfig: {
        maxDate: 'today',
        enableTime: true,
        enableSeconds: true,
        time_24hr: true
      },
      i: {
        responseCode: '',
        responseError: '',
        periodEnd: '',
        periodStart: '',
        country: '',
        brand: '',
        sessionId: '',
        requestId: '',
        accountId: '',
        paymentId: '',
        authorizationId: '',
        psuIdHash: '',
        state: ''
      },
      d: {
        responseCode: '',
        responseError: '',
        periodEnd: '',
        periodStart: '',
        country: '',
        brand: '',
        sessionId: '',
        requestId: '',
        accountId: '',
        paymentId: '',
        authorizationId: '',
        psuIdHash: '',
        state: ''
      }
    }
  },
  components: {
    flatPickr
  },
  async mounted() { // get full list of ASPSPs when page is loaded
    this.getASPSPs()
  },
  computed: {
    canSubmit() {
      for (const [k, v] of Object.entries(this.i)) {
        if (this.d[k] !== v) {
          return true
        }
      }
      return false
    },
    canReset() {
      for (const [k, v] of Object.entries(this.i)) {
        if (this.d[k] !== v || v !== '') {
          return true
        }
      }
      return false
    },
    ...mapGetters(['idToken']) // for ASPSP list
  },
  watch: {
    periodEnd: function (v) {
      if (v) {
        this.i.periodEnd = new Date(v).toISOString()
      }
    },
    'i.periodEnd': function (v) {
      if (!v) {
        this.periodEnd = null
      } else if (v === this.d.periodEnd) {
        this.periodEnd = new Date(v).toLocaleString('lt-LT') // to be yyyy-mm-dd hh:mm:ss local time
      }
    }
  },
  methods: {
    ...mapActions(['pushAlertMessage']),
    submit() {
      for (const [k, v] of Object.entries(this.i)) {
        this.d[k] = v
      }
      this.$emit('submit', this.i)
    },
    reset() {
      let d = false
      for (const [k, v] of Object.entries(this.i)) {
        if (this.d[k] !== v) {
          this.i[k] = this.d[k]
          d = true
        }
      }
      if (d) {
        return
      }
      for (const k of Object.keys(this.i)) {
        this.i[k] = this.d[k] = ''
      }
      this.$emit('reset', this.i)
    },
    async getASPSPs() { // adapted from ApplicationStatistics.vue
      this.loadingASPSPs = true
      try {
        const aspspsResponse = await axios.get(
          '/api/aspsps', {
            headers: {
              Authorization: `Bearer ${this.idToken.token}`
            }
          }
        )
        const countries = {}
        for (const aspsp of aspspsResponse.data.aspsps) {
          const countryASPSPs = countries[aspsp.country] || []
          aspsp.psu_types = aspsp.psu_types.sort()
          countryASPSPs.push(aspsp)
          countries[aspsp.country] = countryASPSPs.sort((a, b) => a.name.localeCompare(b.name))
        }
        this.countries = countries
      } catch (e) {
        console.log(e)
        this.pushAlertMessage({
          message: 'Unable to get ASPSPs'
        })
      } finally {
        this.loadingASPSPs = false
      }
    }
  }
}
</script>

<style lang="scss">
</style>
